import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Popover,
  List,
  Divider,
} from '@lockerpm/design';

import relayServices from '../../services/relay';
import common from "../../utils/common";

const PrivateEmails = (props) => {
  const { t } = useTranslation();
  const {
    className = '',
    value = '',
    disabled = false,
    onFill = () => {}
  } = props;

  const planLimit = useSelector((state) => state.payment.planLimit);

  const [aliases, setAliases] = useState([]);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    getAddresses();
  }, [])

  const getAddresses = async () => {
    const res = await relayServices.get_addresses({ paging: 0 });
    setAliases(res)
  }

  const addAddress = async () => {
    setCreating(true);
    await relayServices.create_address().then(async (res) => {
      onFill(res.full_address);
      await getAddresses();
      setCreating(false);
    }).catch((error) => {
      global.pushError(error)
    });
  }

  const handleAddAddress = () => {
    if (creating) {
      return;
    }
    if (aliases.length < planLimit?.plan_limit?.relay_addresses) {
      addAddress();
    } else {
      common.togglePlanNoticeModal(() => addAddress())
    }
  }

  return (
    <div className={`private-emails ${className}`}>
      <div className="text-right">
        <Popover
          placement="bottomRight"
          trigger={['hover']}
          disabled={disabled}
          overlayInnerStyle={{
            padding: 0
          }}
          content={
            disabled ? <></> : <div className="max-w-[280px]">
              {
                aliases?.length > 0 ? <List
                  size="small"
                  itemLayout="horizontal"
                  dataSource={aliases}
                  style={{
                    maxHeight: 154,
                    overflowY: 'auto',
                    padding: "0 8px"
                  }}

                  renderItem={item => (
                    <List.Item
                      style={{ padding: 8 }}
                      className={`hover:text-primary cursor-pointer ${value == item.full_address ? 'text-primary' : ''}`}
                      onClick={() => onFill(item.full_address)}
                    >
                      <p
                        className="text-limited"
                        title={item.full_address}
                      >{item.full_address}</p>
                    </List.Item>
                  )}
                /> : <div className="px-4 py-3 text-black-500">
                  {t('hide_your_email.no_alias')}
                </div>
              }
              
              <Divider className="m-0"/>
              <p
                className="text-primary p-[8px] cursor-pointer font-semibold px-[16px]"
                onClick={() => handleAddAddress()}
              >
                {t('hide_your_email.generate_new')}
              </p>
            </div>
          }
        >
          <span className={`font-semibold ${disabled ? 'text-black-500' : 'text-primary cursor-pointer'}`}>
            {t('hide_your_email.title')}
          </span>
        </Popover>
      </div>
    </div>
  );
}

export default PrivateEmails;